import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MapPin, Clock, CheckCircle, AlertCircle, Phone } from 'lucide-react';
import Navbar from '../components/Navbar';

export default function Entrega() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const steps = [
    { icon: <CheckCircle className="w-5 h-5 text-green-500" />, text: t('delivery.step1') },
    { icon: <CheckCircle className="w-5 h-5 text-green-500" />, text: t('delivery.step2') },
    { icon: <CheckCircle className="w-5 h-5 text-green-500" />, text: t('delivery.step3') },
    { icon: <CheckCircle className="w-5 h-5 text-green-500" />, text: t('delivery.step4') },
    { icon: <CheckCircle className="w-5 h-5 text-green-500" />, text: t('delivery.step5') },
  ];

  const zones = [
    t('delivery.zone1'),
    t('delivery.zone2'),
    t('delivery.zone3'),
    t('delivery.zone4'),
  ];

  return (
    <div className="min-h-screen bg-gray-50 pb-24 lg:pb-0">
      <Navbar />
      <div className="container mx-auto px-4 md:px-6 max-w-3xl py-12">
        <button
          onClick={() => navigate(-1)}
          className="mb-8 text-sm text-gray-500 hover:text-[#134168] transition-colors"
        >
          {t('legal.back')}
        </button>

        <h1 className="text-4xl font-heading font-bold text-[#134168] mb-2">
          {t('delivery.title')}
        </h1>
        <p className="text-sm text-gray-400 mb-8">{t('legal.lastUpdatedMay')}</p>

        {/* Descripción */}
        <div className="bg-white rounded-3xl p-8 shadow-sm mb-6 text-sm text-gray-700 leading-relaxed">
          <p>{t('delivery.intro')}</p>
        </div>

        {/* Cómo funciona */}
        <div className="bg-white rounded-3xl p-8 shadow-sm mb-6">
          <h2 className="text-lg font-bold text-[#134168] mb-4">{t('delivery.howTitle')}</h2>
          <ol className="space-y-3">
            {steps.map((s, i) => (
              <li key={i} className="flex items-start gap-3 text-sm text-gray-700">
                {s.icon}
                <span><strong>{i + 1}.</strong> {s.text}</span>
              </li>
            ))}
          </ol>
        </div>

        {/* Horarios */}
        <div className="bg-white rounded-3xl p-8 shadow-sm mb-6 flex gap-4 items-start">
          <div className="w-12 h-12 bg-blue-50 rounded-2xl flex items-center justify-center shrink-0">
            <Clock className="w-6 h-6 text-[#134168]" />
          </div>
          <div>
            <h2 className="font-bold text-[#134168] mb-1">{t('delivery.scheduleTitle')}</h2>
            <p className="text-sm text-gray-600">{t('delivery.scheduleText')}</p>
          </div>
        </div>

        {/* Zonas de cobertura */}
        <div className="bg-white rounded-3xl p-8 shadow-sm mb-6">
          <div className="flex gap-3 items-center mb-4">
            <MapPin className="w-5 h-5 text-[#134168]" />
            <h2 className="font-bold text-[#134168]">{t('delivery.zonesTitle')}</h2>
          </div>
          <ul className="space-y-2">
            {zones.map((z, i) => (
              <li key={i} className="text-sm text-gray-700 flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-[#39b4aa] shrink-0" />
                {z}
              </li>
            ))}
          </ul>
        </div>

        {/* Nota importante */}
        <div className="bg-amber-50 border border-amber-200 rounded-3xl p-6 mb-6 flex gap-3 items-start">
          <AlertCircle className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />
          <p className="text-sm text-amber-800">{t('delivery.disclaimer')}</p>
        </div>

        {/* Contacto */}
        <div className="bg-[#134168] text-white rounded-3xl p-6 flex gap-4 items-center">
          <Phone className="w-6 h-6 shrink-0" />
          <div>
            <p className="font-bold text-sm mb-0.5">{t('delivery.contactTitle')}</p>
            <p className="text-blue-100 text-sm">{t('delivery.contactText')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
